// The names this game's saves go under in the browser's storage. Apart from
// src/boundary/save.ts so that src/main/door.ts, which runs before the page
// draws, can read them without loading the save parser.

export const SAVE_KEY = "ternion.v3"
export const V2_SAVE_KEY = "ternion.v2"
export const V1_SAVE_KEY = "ternion.v1"
// set once this browser has seen the introit (src/main/teaser.ts)
export const BEEN_KEY = "ternion.been"
